module.exports = __webpack_public_path__ + "static/img/fish.8874db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/fish.png
// module id = Hdqq
// module chunks = 1